import { useMemo } from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettingsParams } from './useSettingsParams';

export const useShouldUseMobileSettings = () => {
  const { isCssPerBreakpoint } = useEnvironment();
  const settings = useSettings();
  const settingsParams = useSettingsParams();

  return useMemo(() => {
    const useMobileSettingsInStudio = settingsParams?.useMobileSettingsInStudio;

    if (
      useMobileSettingsInStudio &&
      typeof useMobileSettingsInStudio === 'object' &&
      'key' in useMobileSettingsInStudio
    ) {
      try {
        const value = settings.get(useMobileSettingsInStudio);
        return value !== undefined ? value : !isCssPerBreakpoint;
      } catch (e) {
        return !isCssPerBreakpoint;
      }
    }

    return !isCssPerBreakpoint;
  }, [isCssPerBreakpoint, settings, settingsParams]);
};
